import styled from 'styled-components';

const Page = styled.div`
  align-items: center;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  padding: 56px 24px 24px;
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;
  max-width: 400px;
`;

const LogoImage = styled.img`
  height: 48px;
  object-fit: contain;
  width: auto;

  @media (min-width: 1024px) {
    height: 72px;
  }
`;

const StatusRow = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;
`;

export { Page, Content, LogoImage, StatusRow };
